import { render, staticRenderFns } from "./BallotEntryHeader.vue?vue&type=template&id=a212ee76&"
import script from "./BallotEntryHeader.vue?vue&type=script&lang=js&"
export * from "./BallotEntryHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports